<template>
  <book />
</template>

<script>
import Book from "@/components/book/book";

export default {
  components: {
    Book
  }
};
</script>

<style></style>
